import React from "react";
var __jsx = React.createElement;
import stl from "./SuggestionsContainer.module.css";
import useIsMobile from "@hooks/useIsMobile";
import useHelpers from "@hooks/useHelpers";
import useKeyPressSwitch from "@hooks/useKeyPressSwitch";
import { useEffect, useState } from "react";
import { ModernCard } from "@/components/SearchComponent/ModernCard";
import { Link } from "react-router-dom";
import { CDN_LINK } from "@globalConfig";
var SuggestionsContainerOnline = function SuggestionsContainerOnline(props) {
  var isMobile = useIsMobile();
  var _useState = useState(false),
    showOldCard = _useState[0],
    setShowOldCard = _useState[1];
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var _useState2 = useState(props.similarPosts),
    similarPosts = _useState2[0],
    setSimilarPosts = _useState2[1];
  var handleKeyPressSwitch = function handleKeyPressSwitch() {
    setShowOldCard(!showOldCard);
  };
  useKeyPressSwitch(handleKeyPressSwitch);
  useEffect(function () {
    if (isMobile) {
      similarPosts && setSimilarPosts(similarPosts === null || similarPosts === void 0 ? void 0 : similarPosts.slice(0, 4));
    }
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.SuggestionsContainerOnline
  }, /*#__PURE__*/React.createElement("div", {
    className: [stl.revampedHome].join(" ")
  }, /*#__PURE__*/React.createElement("h2", {
    className: ["big", stl.revampedTitle, "!px-4"].join(" ")
  }, props.title), /*#__PURE__*/React.createElement("ul", {
    className: "flex gap-5 flex-nowrap overflow-auto px-5 snap-x snap-mandatory mt-8 lg:grid lg:grid-cols-[repeat(auto-fill,minmax(273px,1fr))] lg:gap-5 list-none lg:pb-10 lg:px-0"
  }, similarPosts && (similarPosts === null || similarPosts === void 0 ? void 0 : similarPosts.map(function (post, i) {
    return /*#__PURE__*/React.createElement("li", {
      className: "flex-none snap-center min-h-full lg:w-full w-[300px]"
    }, /*#__PURE__*/React.createElement(ModernCard, {
      key: "suggestionsContainerOnline_".concat(post.id),
      post: post,
      rank: i,
      page: 1,
      fromHomePage: true,
      isOnline: true,
      sectionType: "home page",
      titleTag: "h3"
    }));
  })), isMobile && similarPosts.length > 3 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", {
    className: "flex items-center justify-center rounded-[4px] bg-[#3C56D4] shadow-md w-[165px] flex-none snap-center p-6 gap-1"
  }, /*#__PURE__*/React.createElement(Link, {
    to: createUrl("/filters", {}, {
      referral_location: "Home",
      browse_variant: "view_all",
      variant_value: "view all"
    }),
    className: "flex items-center gap-0.5"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-white text-right text-[16px] not-italic font-bold leading-6"
  }, props.btnTxt), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("img", {
    className: "en:transform en:scale-[-1]",
    src: CDN_LINK + "/assets/images/arrow-left-white.svg",
    alt: ""
  })))))), !isMobile && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
    href: createUrl("/filters", {}, {
      referral_location: "Home",
      browse_variant: "view_all",
      variant_value: "view all"
    }),
    state: {
      search_type: "homepage_listing"
    },
    className: [["redBtn", "moreSameCar", stl.moreSameCar, stl.showMorwBtn].join(" "), "!hidden lg:flex"].join(" "),
    id: "more-cars-link"
  }, props.btnTxt)))));
};
export default SuggestionsContainerOnline;